import { render, staticRenderFns } from "./SlideTripDocument.vue?vue&type=template&id=53640b60&scoped=true"
import script from "./SlideTripDocument.vue?vue&type=script&lang=js"
export * from "./SlideTripDocument.vue?vue&type=script&lang=js"
import style0 from "./SlideTripDocument.vue?vue&type=style&index=0&id=53640b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53640b60",
  null
  
)

export default component.exports